import React from 'react'
import style from './Disclaimer.module.scss'
import replaceText from '../../utils/replaceText'
import RawHtmlScript from '../ArticleContent/RawHtmlScript'

// Rendered as a div, not a p: the token markdown resolves to block-level HTML,
// and a <div> inside a <p> makes the browser close the paragraph early, which
// left the risk warning sitting outside the element it was supposed to style.
const Disclaimer = ({ disclaimer, tokens }) => {
  return (
    <div className={style.disclaimer}>
      <RawHtmlScript html={replaceText(tokens, disclaimer)} />
    </div>
  )
}

export default Disclaimer
